/**
 * The dock's progress bar — spec §F6 ("progress bar polling job"), the mockup's
 * `.progressbar`.
 *
 * **The job's own percentage, not an animation.** The mockup ran a `setInterval` that
 * crept the bar to 96 % and then jumped it to 100 %, because there was nothing behind it;
 * §E7 gives every tool a `ctx.progress(pct)` and §D6 serves it, so the bar reports what the
 * run has actually done. A floor of 4 % keeps a just-queued job visible — a zero-width bar
 * reads as a broken one.
 */
export interface ProgressBarProps {
  /** 0–100, the §D6 job's own `progress`. */
  value: number;
  label: string;
}

export const PROGRESS_FLOOR = 4;

export function ProgressBar({ value, label }: ProgressBarProps) {
  const pct = Math.max(PROGRESS_FLOOR, Math.min(100, Math.round(value)));
  return (
    <div
      className="progressbar"
      role="progressbar"
      aria-label={label}
      aria-valuenow={Math.round(value)}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div style={{ width: `${pct}%` }} />
    </div>
  );
}

export default ProgressBar;
